import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppointmentDemandList, CustomerRejectedDemand } from 'projects/Administration/src/app/business-entities/appointment-demand-list-view-model';
import { AppointmentServiceDetails } from 'projects/Administration/src/app/business-entities/appointment-service-details-view-model';
import { CustomerDropdownModel } from 'projects/Administration/src/app/business-entities/customer-view.model';
import { PackageBOMResponseModel } from 'projects/Administration/src/app/business-entities/package-list-model';
import { PartNumberMultiInventeryModel, PartsListViewModel } from 'projects/Administration/src/app/business-entities/parts-list-view-model';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { CustomerService } from 'projects/Administration/src/app/business-services/customer.service';
import { DocumentService } from 'projects/Administration/src/app/business-services/document.service';
import { PartsBusinessService } from 'projects/Administration/src/app/business-services/parts.service';
import { ServicesService } from 'projects/Administration/src/app/business-services/services.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Subscription } from 'rxjs';
import { CustomPaggerService } from '../../../../../../../../Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdModalContent } from '../../../../../../../../Autofacets-Core/src/app/shared/delete-modal.component';
import * as Enums from '../../../../../../../../Autofacets-Core/src/app/utils/enums';
import { Utility } from '../../../../../../../../Autofacets-Core/src/app/utils/utility';
import { AppointmentDetail } from '../../../../../business-entities/appointmentDetail-model';
import { LaborDetailsViewModel } from '../../../../../business-entities/labor-details-view-model';
import { PartDetailsViewModel } from '../../../../../business-entities/part-details-view-model';
import { ServicePackageBOM, ServiceViewModel } from '../../../../../business-entities/service-view-model';
import { AppointmentWorkOrderService } from '../../../../../business-services/appointment-work-order.service';
import { AppointmentService } from '../../../../../business-services/appointment.service';
import { EditAppointmentService } from '../../../../../business-services/edit-appointment.service';
import { LaborService } from '../../../../../business-services/labor.service';
import { PackageService } from '../../../../../business-services/package.service';
import { SettingService } from '../../../../../business-services/setting.service';
import { CultureLocaleService } from '../../../../../services/culture-locale.service';
import { SearchLaborComponent } from '../../../../labor/search-labor/search-labor.component';
import { SearchPackageComponent } from '../../../../package/search-package/search-package.component';
import { SearchAlternatePartsComponent } from '../../../../parts/search-parts/search-alternate-parts/search-alternate-parts.component';
import { SearchPartsComponent } from '../../../../parts/search-parts/search-parts.component';
import { SearchReplacementPartsComponent } from '../../../../parts/search-parts/search-replacement-parts/search-replacement-parts.component';
import { SearchServiceComponent } from '../../../../services/search-service/search-service.component';



@Component({
  selector: 'app-add-additional-work-job',
  templateUrl: './add-additional-work-job.component.html',
  styleUrls: ['./add-additional-work-job.component.css']
})
export class AddAdditionalWorkJobComponent implements OnInit {
  openPanels: Array<string> = ['first','second', 'third','four'];
  currency: string;
  isBtnEnabled: boolean = false;
  appointmentServiceDetail: AppointmentServiceDetails;
  dealerId: string = '';
  services: ServiceViewModel[] = [];
  dealerPartList: PartDetailsViewModel[] = [];
  partSelected: string;
  currentlagSub: Subscription;
  popupCloseResult = false;
  searchterm: string;
  packageSelected: string;
  packageList: any[];
  UnitPriceDealer: number;
  contactDetails: AppointmentDetail;
  selectedPartList: PartsListViewModel[] = [];
  selectedLaborList: LaborDetailsViewModel[] = [];
  dealerServicesList: ServiceViewModel[] = [];
  packageVersionBOM: PackageBOMResponseModel[] = [];
  featureList: Features[] = [];
  customerList: CustomerDropdownModel[] = [];
  isShowTax: boolean = false;
  personelDiscount: any;
  materialDiscount: any;
  isWarrantyDocumentSigned: boolean = false;
  isDMSEnable: boolean = false;
  isDmsPackageSync: boolean = false;
  selectPackageVersionName: string;
  // isDiscountDemandOrJobDetailLevelError:boolean=false;
  customerRejectedDemand: CustomerRejectedDemand[] = [];
  isAllDemandSelected: boolean = false
  serviceList: any[] = [];
  isQuoteCreated: boolean = false
  allAppointmentDemandList: Array<AppointmentDemandList>;
  isWarningLightFeature: boolean =false;
  selectPackageMakeCode:string = "";
  selectPackageSourceId:number = 0;
  CentralPart: boolean = false;
  isIntegrationWithParts:boolean = false;
  hideServiceAsDemand:boolean = false;
  isAllowToCreateQuote: boolean = true;
  constructor(
    public editAppointmentService: EditAppointmentService,
    public settingService: SettingService,
    public workOrderAdditionalService: AppointmentWorkOrderService,
    private readonly cookieservice: CookieService,
    private readonly spinner: NgxSpinnerService,
    private readonly appointmentService: AppointmentService,
    private readonly modalService: NgbModal,
    private readonly translate: TranslateService,
    private readonly toastr: ToastrService,
    public pService: CustomPaggerService,
    public cultureLocaleService: CultureLocaleService,
    private readonly partService: PartsBusinessService,
    private readonly activeModal: NgbActiveModal,
    private readonly serviceServices: ServicesService,
    private readonly laborService: LaborService,
    private readonly packageService: PackageService,
    private readonly secureStorage: SecureStorage,
    private readonly globalSetting: GlobalSetting,
    private readonly customerService: CustomerService,
    private readonly documentService: DocumentService,
    private readonly cdr: ChangeDetectorRef,
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['packageNumber', 'packageNameEn', 'packageNameNl', 'packageNameNo'];
    this.pService.searchTerm = '';

  }

  ngOnInit(): void {
    this.hideServiceAsDemand = localStorage.getItem("Theme") === 'mg';
    this.getFeatures();
    this.currency = this.cultureLocaleService.currency;
    if(this.editAppointmentService.appointmentDetails.workorderStatus !== Enums.WOStatusName.Waitingforcustomer 
      && this.editAppointmentService.appointmentDetails.workorderStatus !== Enums.WOStatusName.Cararrived
      && this.editAppointmentService.appointmentDetails.workorderStatus !== Enums.WOStatusName.Prepared
      && this.editAppointmentService.appointmentDetails.workorderStatus !== Enums.WOStatusName.WorkRequest
    )
    {
      this.isBtnEnabled = true;
    }
    this.UnitPriceDealer = this.editAppointmentService.appointmentDetails.unitPrice;

    this.GetAdditionalServiceDetail();
    this.GetContactDetails();
    this.getCustomerList();
    this.GetWarrantyDocumentStatus();
  }
  async getCustomerList() {
    this.spinner.show();
    await this.customerService.getCustomerDropdownByLicensePlateNo(this.editAppointmentService.appointmentDetails.licensePlate).then((response) => {
      this.spinner.hide();
      this.customerList = response.responseObject;
    }, _error => {
      this.spinner.hide()
    });
  }


  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 's') {
      event.preventDefault();     
      this.SaveAppointmentData();                
    }
  }

  checkWarranty(i: number) {
    if (!this.appointmentServiceDetail.appointmentDemandList[i].isInWarranty) {
      let makeCode = this.contactDetails.companyMakeCode;

      let index = this.customerList.findIndex(x => x.customerNo.includes(makeCode) && x.customerGroup == "GARANTI")
      if (index >= 0) {
        this.appointmentServiceDetail.appointmentDemandList[i].billToCustomer = this.customerList[index].customerNo;
      }else{
        let indexDefault = this.customerList.findIndex(x=>x.customerNo == "INT-BB GARANTI-12")
        if(indexDefault >= 0){
          this.appointmentServiceDetail.appointmentDemandList[i].billToCustomer = this.customerList[indexDefault].customerNo;
        }
      }
    }
    else {
      this.appointmentServiceDetail.appointmentDemandList[i].billToCustomer = this.contactDetails.billtoCustomerNo;
    }
  }

  ViewComment(comment) {
    let msg = comment
    let modelHeadermsg = this.translate.instant("lblCustomerComment");
    const modalRef = this.modalService.open(NgInfoModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = msg;
    modalRef.result.then((_result) => { 
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
    });
  }

  onBlurPersonnelDiscount(event) {
    let value = this.globalSetting.getFormattedprice(event.target.value);
    if (parseInt(value) <= 0 || parseInt(value) >= 100) {
      this.workOrderAdditionalService.isAdditionalJobDetailDiscountError = true;
      let msg = this.translate.instant("lblValidInputForDiscount")
      this.toastr.error(msg);
      return;
    }
    this.workOrderAdditionalService.isAdditionalJobDetailDiscountError = false;
    this.personelDiscount = event.target.value;
    this.appointmentServiceDetail?.appointmentJobDetailList.forEach(jobDetail => {
      if (jobDetail.costType === 'Personnel' && this.editAppointmentService.isEdit && !(jobDetail.isMoved || jobDetail.isCustomerApporved === -1 || jobDetail.isAdminApproved === -1 || jobDetail.isCDSSApproved === -1))
        jobDetail.discount = event.target.value;
    });

  }

  onBlurMaterialDiscount(event) {
    let value = this.globalSetting.getFormattedprice(event.target.value);
    if (parseInt(value) <= 0 || parseInt(value) >= 100) {
      this.workOrderAdditionalService.isAdditionalJobDetailDiscountError = true;
      let msg = this.translate.instant("lblValidInputForDiscount")
      this.toastr.error(msg);
      return;
    }
    this.workOrderAdditionalService.isAdditionalJobDetailDiscountError = false;
    this.materialDiscount = event.target.value;
    this.appointmentServiceDetail?.appointmentJobDetailList.forEach(jobDetail => {
      if (jobDetail.costType === 'Material' && this.editAppointmentService.isEdit && !(jobDetail.isMoved || jobDetail.isCustomerApporved === -1 || jobDetail.isAdminApproved === -1 || jobDetail.isCDSSApproved === -1)) {
        jobDetail.discount = event.target.value;
      }
    });
  }
  onBlurQuntity(e, _i){
    let plannedQuantity= JSON.parse(JSON.stringify(e.target.value));
    plannedQuantity = Number(plannedQuantity.toString().replace(',', '.'));
    this.appointmentServiceDetail.appointmentJobDetailList[_i].plannedQuantity = plannedQuantity;
  }
  onBlurDiscount(event, index: number) {
    let value = this.globalSetting.getFormattedprice(event.target.value);
    if (parseFloat(value) < 0.01 || parseFloat(value) > 100) {
      this.workOrderAdditionalService.isAdditionalJobDetailDiscountError = true;
      let msg = this.translate.instant("lblValidInputForDiscount")
      this.toastr.error(msg);
      return;
    }
    this.workOrderAdditionalService.isAdditionalJobDetailDiscountError = false;
    if (!this.empty(this.appointmentServiceDetail.appointmentJobDetailList[index].fixedPrice)) {
      const previousDiscount = this.appointmentServiceDetail.appointmentJobDetailList[index].discount;
      const newValue = event.target.value;
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.modelHeader = this.translate.instant("lblConfirmation");
      modalRef.componentInstance.modelBody = this.translate.instant("lblDiscountChangeWithFixedPriceWarning");
      modalRef.result.then((_result) => {
        // This is intentional
      }, (reason) => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          this.appointmentServiceDetail.appointmentJobDetailList[index].discount = newValue;
        } else {
          event.target.value = previousDiscount;
        }
      });
      return;
    }
    this.appointmentServiceDetail.appointmentJobDetailList[index].discount = event.target.value;
  }
  onBlurUnitPrice(event,index) {
    let unitPrice= JSON.parse(JSON.stringify(event.target.value));
    unitPrice = parseFloat(unitPrice.toString().replace('\u00A0', '').replace(' ','').replace(',','.'));
    this.appointmentServiceDetail.appointmentJobDetailList[index].unitPrice = unitPrice;
  }
  checkDiscount(event): void {
    const isDigit = Utility.isDigit(event);
    const isDecimalPoint = Utility.isDecimalPoint(event);
    if (!isDecimalPoint && !isDigit) {
      event.preventDefault();
    }
  }

  async getFeatures() {
    if (this.secureStorage.getKeyData('feature')) {
      this.featureList = this.secureStorage.getKeyData('feature');
      if (this.featureList && this.featureList.length > 0) {
        this.isShowTax = this.featureList.find(x => x.featureCode === Enums.FeatureCode.Tax)?.isActive;
        this.isDMSEnable = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
        this.isDmsPackageSync = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DmsPackageSync)?.isActive;
        if(this.featureList.find(x => x.featureCode === Enums.FeatureCode.WarningLight))
        this.isWarningLightFeature=this.featureList.find(x => x.featureCode === Enums.FeatureCode.WarningLight)?.isActive;
        this.isIntegrationWithParts = this.featureList.find(x=> x.featureCode === Enums.FeatureCode.PARTS)?.isActive;
        this.CentralPart = this.featureList.find(x => x.featureCode === Enums.FeatureCode.CentralPart)?.isActive;
      }
    }
  }


  async GetContactDetails() {
    let language = this.cookieservice.get('userSelectedLanguage')
    await this.appointmentService.GetAppointmentDetail(this.editAppointmentService.appointmentDetails.id, language).then(result => {
      if (result.responseCode === Enums.ErrorCodes.SuccessCode) {
        this.contactDetails = result.responseObject;
        this.cdr.detectChanges();
      }
    })
  }

  async GetAdditionalServiceDetail() {
    await this.appointmentService.GetAdditionalServiceDetail(this.editAppointmentService.appointmentDetails.id).then(data => {
      if (data.responseObject.errorCount > 0) {
        this.appointmentServiceDetail = {
          totalPrice: 0,
          totalTime: 0,
          totalInvoicePrice: 0,
          appointmentDemandList: [],
          priceForDisply: '',
          rentalCompanyMakeName: '',
          appointmentJobDetailList: [],
          appointmentJobList: [],
          appointmentPriceDetails: []
        }
        this.workOrderAdditionalService.totalPrice = null;
        this.workOrderAdditionalService.totalTime = null;
        this.workOrderAdditionalService.totalInvoicePrice = null;
      }
      else {
        this.appointmentServiceDetail = data.responseObject;

        this.allAppointmentDemandList = this.appointmentServiceDetail.appointmentDemandList;
        this.mapIndexWithJobDetails();
        this.workOrderAdditionalService.totalPrice = this.appointmentServiceDetail.totalPrice;
        this.workOrderAdditionalService.totalTime = this.appointmentServiceDetail.totalTime;
        this.workOrderAdditionalService.totalInvoicePrice = this.appointmentServiceDetail.totalInvoicePrice;
        this.workOrderAdditionalService.appointmentPriceDetails = this.appointmentServiceDetail.appointmentPriceDetails;
        this.appointmentServiceDetail.appointmentJobList?.map((object) => {
          let jobDetails = this.workOrderAdditionalService.appointmentJobDetailToUpdate?.find((detail) => detail.jobId == object.jobId && detail.costType == 'Personnel');
          if(jobDetails != null || jobDetails != undefined){
            object.isServiceAdded = true;
          }
        });

        this.customerRejectedDemand = this.appointmentServiceDetail.appointmentDemandList?.filter(x => x.isAdditionalWork && (x.isCustomerApporved == -1 || x.isAdminApproved == -1 || x.isCDSSApproved == -1 || x.isMechanicApproved == -1) && !x.isMoved );
        this.customerRejectedDemand.forEach(demand => {
          if (demand.isQuoteCreated) {
            this.isQuoteCreated = true
          }
        });
        // Use map to get a simple array of "val" values. Ex: [1,4]
        let yFilter = this.customerRejectedDemand.map(itemY => { return itemY.demandNo; });
        // Use filter and "not" includes to filter the full dataset by the filter dataset's val.

        this.appointmentServiceDetail.appointmentDemandList = this.appointmentServiceDetail.appointmentDemandList?.filter(itemX => !yFilter.includes(itemX.demandNo));
        this.appointmentServiceDetail.appointmentJobList = this.appointmentServiceDetail.appointmentJobList?.filter(itemX => !yFilter.includes(itemX.demandNo));
        this.appointmentServiceDetail.appointmentJobDetailList = this.appointmentServiceDetail.appointmentJobDetailList?.filter(itemX => !yFilter.includes(itemX.demandNo));
        this.workOrderAdditionalService.appointmentDemandList = this.appointmentServiceDetail.appointmentDemandList;
        this.workOrderAdditionalService.appointmentJobList = this.appointmentServiceDetail.appointmentJobList;
        this.workOrderAdditionalService.appointmentJobDetailToUpdate = this.appointmentServiceDetail.appointmentJobDetailList.slice();
      }
      const filteredDemands = this.customerRejectedDemand?.filter((demand) => demand.isQuoteCreated === false) || [];
      if(filteredDemands?.length == 0){this.isAllowToCreateQuote = false;}

    })
  }
  mapIndexWithJobDetails() {
    let index = 1;
    let demand = 1;
    this.appointmentServiceDetail.appointmentJobDetailList.forEach((jobDetails) => {
      if (jobDetails.jobId == jobDetails.demandNo && jobDetails.demandNo == demand) {
        jobDetails.jobDetailsId = index;
        demand = jobDetails.demandNo;
        index++;
      } else {
        index = 1;
        jobDetails.jobDetailsId = index;
        demand = jobDetails.demandNo;
        index++;
      }
    })
  }

  AddDemand() {
    if (this.appointmentServiceDetail.appointmentDemandList?.length > 0 && this.empty(this.appointmentServiceDetail.appointmentDemandList[this.appointmentServiceDetail.appointmentDemandList?.length - 1]?.shortDescription)) {
      let msg = this.translate.instant("lblShortDescriptionNotNull");
      this.toastr.error(msg);
      return;
    }
    if (this.allAppointmentDemandList.length == 0) {
      let demand = {
        id: 0,
        demandNo: 101,
        shortDescription: "",
        customerRequirement: "",
        preApproval: "",
        isAddedFromAdmin: true,
        isInWarranty: false,
        isDeleted: false,
        fixedPrice: null,
        sumPerService: 0,
        sumPerServiceInclTax: 0,
        sumPerServiceWithoutDiscountInclVAT:0,
        isAdditionalWork: true,
        totalPriceInclVAT: 0,
        billToCustomer: this.contactDetails.billtoCustomerNo,
        sstOperationId : '',
        sstOperationCode: '',
        demandStaus:''
      }
      this.appointmentServiceDetail.appointmentDemandList.push(demand);
      this.allAppointmentDemandList.push(demand);
    }
    else {
      let lastDemandNo: any = this.allAppointmentDemandList[this.allAppointmentDemandList.length - 1].demandNo;
      lastDemandNo = lastDemandNo + 1;
      if (+lastDemandNo < 100) {
        lastDemandNo = 101
      }
      let demand = {
        id: 0,
        demandNo: +lastDemandNo,
        shortDescription: "",
        customerRequirement: "",
        preApproval: "",
        isAddedFromAdmin: true,
        isInWarranty: false,
        isDeleted: false,
        fixedPrice: null,
        sumPerService: 0,
        sumPerServiceInclTax: 0,
        isAdditionalWork: true,
        totalPriceInclVAT: 0,
        sumPerServiceWithoutDiscountInclVAT:0,
        billToCustomer: this.contactDetails.billtoCustomerNo,
        sstOperationId : '',
        sstOperationCode: '',
        demandStaus:''
      }
      this.appointmentServiceDetail.appointmentDemandList.push(demand);
      this.allAppointmentDemandList.push(demand);
    }
  }

  onBlur(event, index: number, type: string) {
    if (type == "Demands") {
      this.appointmentServiceDetail.appointmentDemandList[index].fixedPrice = event.target.value;
    }
    else if (type == "JobDetails") {
      this.appointmentServiceDetail.appointmentJobDetailList[index].fixedPrice = event.target.value;
    }
  }
  deleteDemand(index: number) {
    if (this.isWarrantyDocumentSigned && this.appointmentServiceDetail.appointmentDemandList[index].isInWarranty) {
      let modelHeadermsg = this.translate.instant("lblDocumentAlreadySigned");
      let modelBodymsg = this.translate.instant("lblWarrantyCanNotDelete");
      const modalRef = this.modalService.open(NgInfoModalContent, { size: 'lg' });
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
    }
    else {
      let modelHeadermsg = this.translate.instant("lblDelete");
      let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblDemands"), true);
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
      modalRef.result.then((_result) => {
        // This is intentional
      }, (reason) => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {

          const demandId = this.appointmentServiceDetail.appointmentDemandList[index].id;
          if (demandId == 0) {
            if (this.appointmentServiceDetail.appointmentJobList.length !== 0 && index < this.appointmentServiceDetail.appointmentJobList.length) {
              let demandNo = this.appointmentServiceDetail.appointmentJobList[index].demandNo;
              if (demandNo) {
                if (this.appointmentServiceDetail.appointmentJobDetailList.length !== 0) {
                  this.appointmentServiceDetail.appointmentJobDetailList = this.appointmentServiceDetail.appointmentJobDetailList.filter(x => x.demandNo != demandNo);
                  this.appointmentServiceDetail.appointmentDemandList.splice(index, 1);
                  this.appointmentServiceDetail.appointmentJobList.splice(index, 1);
                  this.workOrderAdditionalService.appointmentJobDetailToUpdate = this.workOrderAdditionalService.appointmentJobDetailToUpdate.filter(x => x.demandNo != demandNo);

                }
                else {
                  this.appointmentServiceDetail.appointmentDemandList.splice(index, 1);
                  this.appointmentServiceDetail.appointmentJobList.splice(index, 1);

                }

              }
              else {
                this.appointmentServiceDetail.appointmentDemandList.splice(index, 1);
              }
            }
            else {
              this.appointmentServiceDetail.appointmentDemandList.splice(index, 1);

            }
            this.allAppointmentDemandList.forEach(x => {
              if (x.demandNo == this.appointmentServiceDetail.appointmentDemandList[index].demandNo) {
                x.isDeleted = true;
              }
            })
          }
          else {
            this.workOrderAdditionalService.appointmentDemandList[index].isDeleted = true;
            this.workOrderAdditionalService.appointmentJobList[index].isDeleted = true;
            if (index > this.workOrderAdditionalService.appointmentJobDetailToUpdate.length) {
              this.workOrderAdditionalService.appointmentJobDetailToUpdate.forEach(x => {
                if (x.demandNo == this.workOrderAdditionalService.appointmentJobDetailToUpdate[index].demandNo) {
                  x.isDeleted = true;
                }
              })
            }
            else {
              this.workOrderAdditionalService.appointmentDemandList[index].isDeleted = true;
              this.workOrderAdditionalService.appointmentJobList[index].isDeleted = true;
            }

            this.GetJobsDetailsList();
          }
        }

      });
    }
  }

  onBlurShortDescription(index: number) {
    this.mapJobWithDemand(index);
  }

  emitServiceData() {
    this.workOrderAdditionalService.appointmentDemandList = this.appointmentServiceDetail.appointmentDemandList;
    this.workOrderAdditionalService.appointmentJobList = this.appointmentServiceDetail.appointmentJobList;
    this.workOrderAdditionalService.appointmentJobDetailList = this.appointmentServiceDetail.appointmentJobDetailList;
  }

  mapJobWithDemand(index: number) {
    if (index < this.appointmentServiceDetail.appointmentJobList.length) {
      let customerrequirment = this.appointmentServiceDetail.appointmentDemandList[index].shortDescription;
      this.appointmentServiceDetail.appointmentJobList[index].description = customerrequirment;
    }
    else {
      let shortdescription: any = this.appointmentServiceDetail.appointmentDemandList[index].shortDescription.toString();
      let lastDemandNo: any = this.appointmentServiceDetail.appointmentDemandList[this.appointmentServiceDetail.appointmentDemandList.length - 1].demandNo;
      this.appointmentServiceDetail.appointmentJobList.push({
        id: 0,
        demandNo: lastDemandNo,
        jobId: lastDemandNo,
        description: shortdescription,
        appointmentDemandId: 0,
        fixedPrice: null,
        price: 0,
        salesPriceWithoutDiscountInclVAT:0,
        totalTime: 0,
        isAddedFromAdmin: true,
        isAdditionalWork: true
      });
    }
  }
  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  async OpenSearchServicesPopUp(index: number, isServiceAsDemand) {
    if(!isServiceAsDemand)
    {
      if (this.empty(this.appointmentServiceDetail.appointmentDemandList[index]?.shortDescription)) {
        let msg = this.translate.instant("lblJobDescNotNull")
        this.toastr.error(msg);
        return;
      }
    } else if (isServiceAsDemand && this.appointmentServiceDetail.appointmentDemandList?.length > 0 && this.empty(this.appointmentServiceDetail.appointmentDemandList[this.appointmentServiceDetail.appointmentDemandList?.length - 1]?.shortDescription)) {
      let msg = this.translate.instant("lblShortDescriptionNotNull");
      this.toastr.error(msg);
      return;
    }
    
    this.services = [];
    this.serviceServices.registrationDate = this.contactDetails.registrationDate;
    this.serviceServices.engineTypeCode = this.contactDetails.engineTypeCode;
    this.serviceServices.vehicleTypeCode = this.contactDetails.vehicleTypeCode;
    this.serviceServices.companyMakeCode = this.contactDetails.companyMakeCode;
    this.serviceServices.previousKilometer = this.contactDetails.previousKilometer;
    this.serviceServices.dealerId = this.editAppointmentService.appointmentDetails.dealerId;
    this.serviceServices.locationCode = this.contactDetails.locationCode;
    this.serviceServices.customerNo = isServiceAsDemand? this.contactDetails.billtoCustomerNo : this.appointmentServiceDetail.appointmentDemandList[index].billToCustomer;
    let currentJobId = this.appointmentServiceDetail.appointmentJobList[index]?.jobId;
    
    const modalRef = this.modalService.open(SearchServiceComponent, {
      windowClass: 'pop-wid1366',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    let selectedServiceIdArray = this.appointmentServiceDetail.appointmentJobDetailList.map((x) => x.serviceId)
    modalRef.componentInstance.selectedServiceIdArray = selectedServiceIdArray;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.services = this.serviceServices.SelectedServices;
      let serviceExits = false;
      for (const item of this.services) {
        if (this.appointmentServiceDetail.appointmentJobDetailList.findIndex(y => y.jobId == currentJobId && y.bomTypeId == 1 && y.salesPart == item.serviceNo) != -1) {
          serviceExits = true;
        }
      }

      if (serviceExits && reason === true) {
        let serviceErrorMessage = this.translate.instant("lblServiceAlreadyExists");
        this.toastr.error(serviceErrorMessage);
        modalRef.dismiss(true);
      } else {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          if (isServiceAsDemand === false) {
            this.mapJobWithJobDetails(index, false);
          }
          else {
            this.GetServiceAsDemand()
          }
        }
      }
    })
  }

  async getDealerService(index: number) {
    let language = this.cookieservice.get('userSelectedLanguage')
    let dateFormatRegistrationDate = Utility.getDateStringToDate(this.contactDetails.registrationDate);
    let date = new Date();
    let vehicleAge = Utility.monthDiff(dateFormatRegistrationDate, date);

    let model = {
      fuelType: this.contactDetails.engineTypeCode,
      vehicleType: this.contactDetails.vehicleTypeCode,
      brand: this.contactDetails.companyMakeCode,
      model: this.contactDetails.modelName,
      language: language,
      mileage: this.contactDetails.previousKilometer,
      vehicleAge: vehicleAge,
      dealerId: this.editAppointmentService.appointmentDetails.dealerId,
      customerNo: this.appointmentServiceDetail.appointmentDemandList[index].billToCustomer
    }
    this.spinner.show();
    let serviceCategories = [];
    this.dealerServicesList = [];
    await this.serviceServices.GetServicesByDealerId(model).then(result => {
      this.spinner.hide();
      if (result.responseCode === Enums.ErrorCodes.SuccessCode) {
        serviceCategories = result.responseObject;

        if (serviceCategories.length > 0) {
          serviceCategories.forEach(el => {
            let mappedService = el.services;
            if (mappedService.length > 0) {
              mappedService.forEach(element => {
                this.dealerServicesList.push(element);
              });
            }
          });
        }
      }
    });
  }

  async OpenSearchPackagePopUp(index: number, isPackageAsDemand: boolean) {
    if (!isPackageAsDemand && this.empty(this.appointmentServiceDetail.appointmentDemandList[index].shortDescription)) {
      let msg = this.translate.instant("lblJobDescNotNull")
      this.toastr.error(msg);
      return;
    } else if (isPackageAsDemand && this.appointmentServiceDetail.appointmentDemandList?.length > 0 && this.empty(this.appointmentServiceDetail.appointmentDemandList[this.appointmentServiceDetail.appointmentDemandList?.length - 1]?.shortDescription)) {
      let msg = this.translate.instant("lblShortDescriptionNotNull");
      this.toastr.error(msg);
      return;
    }
    if (this.dealerServicesList.length == 0) {
      await this.getDealerService(index);
    }
    if(localStorage.getItem("Theme") === 'mg'){
      this.partService.locationCode = this.contactDetails.dealerDmsNo;
    }else{
      this.partService.locationCode = this.contactDetails.locationCode;
    }
    this.packageService.dealerServicesList = this.dealerServicesList;
    this.packageService.UnitPriceDealer = this.editAppointmentService.appointmentDetails.unitPrice;
    this.packageService.dealerId = this.editAppointmentService.appointmentDetails.dealerId;
    this.packageService.appointmentType = this.editAppointmentService.appointmentDetails.appointmentType;
    this.packageService.isFromAdditionalWork = true;
    const modalRef = this.modalService.open(SearchPackageComponent, {
      windowClass: 'pop-wid1000 pop-hig500',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.companyMakeCode = this.contactDetails.companyMakeCode;
    modalRef.result.then((_result) => { 
       // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.packageVersionBOM = this.packageService.packageVersionBOM;
        this.selectPackageVersionName = this.packageService.packageVersionName;
        this.selectPackageMakeCode = this.packageService.packageMakeCode;
        this.selectPackageSourceId = this.packageService.sourceId;
        if(isPackageAsDemand){
          this.getPackageAsDemand();
         // demandIndex = this.appointmentServiceDetail.appointmentDemandList.length - 1;
          index = this.appointmentServiceDetail.appointmentJobList.length - 1;
        }
        if(this.isDMSEnable && this.isDmsPackageSync){
          if(this.selectPackageSourceId == Constant.PlannerSource){
            this.saveSearchedPackageDetails(index,false);
          }else{
            this.saveSearchedPackageDetails(index,true);
          }
        }else{
          this.saveSearchedPackageDetails(index,true);
        }
      }
    })
  }
  getPackageAsDemand(){
    let selectedPackage: any = this.packageVersionBOM;
    if (this.appointmentServiceDetail.appointmentDemandList.length == 0) {
      this.appointmentServiceDetail.appointmentDemandList.push({
        id: 0,
        demandNo: 101,
        shortDescription: this.selectPackageVersionName,
        customerRequirement: '',
        preApproval: "",
        isAddedFromAdmin: true,
        isInWarranty: false,
        isDeleted: false,
        fixedPrice: null,
        sumPerService: selectedPackage[0].unitPrice,
        sumPerServiceInclTax: 0,
        sumPerServiceWithoutDiscountInclVAT:0,
        isAdditionalWork: true,
        totalPriceInclVAT: 0,
        billToCustomer: this.contactDetails.billtoCustomerNo,
        sstOperationId : '',
        sstOperationCode: '',
        demandStaus:''
      });
      this.appointmentServiceDetail.appointmentJobList.push({
        id: 0,
        demandNo: 101,
        jobId: 101,
        description: '',
        appointmentDemandId: 0,
        fixedPrice: null,
        price: selectedPackage[0].unitPrice,
        salesPriceWithoutDiscountInclVAT:selectedPackage[0].unitPrice,
        totalTime: 0,
        isAddedFromAdmin: true,
        isAdditionalWork: true,
      });
     this.workOrderAdditionalService.appointmentJobList = this.appointmentServiceDetail.appointmentJobList;
      this.workOrderAdditionalService.appointmentDemandList = this.appointmentServiceDetail.appointmentDemandList;
    }
    else {
      let lastDemandNoForDemand = this.getLastDemandNo() + 1;
      if (lastDemandNoForDemand < 100) {
        lastDemandNoForDemand = 101;
      }
      let demand = {
        id: 0,
        demandNo: +lastDemandNoForDemand,
        shortDescription: this.selectPackageVersionName,
        customerRequirement: '',
        preApproval: "",
        isAddedFromAdmin: true,
        isInWarranty: false,
        isDeleted: false,
        fixedPrice: null,
        sumPerService: selectedPackage[0].unitPrice,
        sumPerServiceInclTax: selectedPackage[0].unitPrice,
        isAdditionalWork: true,
        totalPriceInclVAT: 0,
        sumPerServiceWithoutDiscountInclVAT:selectedPackage[0].unitPrice,
        billToCustomer: this.contactDetails.billtoCustomerNo,
        sstOperationId : '',
        sstOperationCode: '',
        demandStaus:''
      }
      this.appointmentServiceDetail.appointmentDemandList.push(demand);
      let lastDemandNoForJob: any = this.appointmentServiceDetail.appointmentDemandList[this.appointmentServiceDetail.appointmentDemandList.length - 1].demandNo;
      this.appointmentServiceDetail.appointmentJobList.push({
        id: 0,
        demandNo: lastDemandNoForJob,
        jobId: lastDemandNoForJob,
        description: '',
        appointmentDemandId: 0,
        fixedPrice: null,
        price: selectedPackage[0].unitPrice,
        salesPriceWithoutDiscountInclVAT:selectedPackage[0].unitPrice,
        totalTime: 0,
        isAddedFromAdmin: true,
        isAdditionalWork: true
      });
    }
  }

  async OpenSearchPartsPopUp(index: number) {
    if (this.empty(this.appointmentServiceDetail.appointmentDemandList[index].shortDescription)) {
      let msg = this.translate.instant("lblJobDescNotNull")
      this.toastr.error(msg);
      return;
    }
    this.selectedPartList = [];
    let currentJobId = this.appointmentServiceDetail.appointmentJobList[index].jobId;
    this.workOrderAdditionalService.qtyCheck = true;
    if(localStorage.getItem("Theme") === 'mg'){
      this.partService.locationCode = this.contactDetails.dealerDmsNo;
    }else{
      this.partService.locationCode = this.contactDetails.locationCode;
    }
    const modalRef = this.modalService.open(SearchPartsComponent, {
      windowClass: 'pop-wid1366 pop-hig500',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.selectedPartList = this.partService.selectedPartListWithAddtionalItems;
      let partsExits = false;
      for (const item of this.selectedPartList) {
        if (this.appointmentServiceDetail.appointmentJobDetailList.findIndex(y => y.jobId == currentJobId && y.bomTypeId == 2 && y.salesPart == item.partNumber) != -1) {
          partsExits = true;
        }
      }
      if (partsExits && reason === true) {
        let laborErrorMessage = this.translate.instant("lblPartAlreadyExists");
        this.toastr.error(laborErrorMessage);
        modalRef.dismiss(true);
        this.spinner.hide();
      } else {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          this.saveSearchedPartsDetails(index);
        }
      }

    })
  }

  async saveSearchedPartsDetails(index: number) {
    let billToCustomer = this.appointmentServiceDetail.appointmentDemandList[index].billToCustomer;
    let demand = this.appointmentServiceDetail.appointmentJobList[index].demandNo;
    let job = this.appointmentServiceDetail.appointmentJobList[index].jobId;
    let appointmentJobId = this.appointmentServiceDetail.appointmentJobList[index].id;
    if (demand < 100) {
      demand = 101
    }
    if (job < 100) {
      job = 101
    }
    this.selectedPartList.forEach(x => {
      this.workOrderAdditionalService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "Material",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.partNumber,
        salesPriceWithoutDiscount: x.unitPrice,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: x.unitPrice,
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice: x.unitPrice,
        quantity: x.qty,
        isAddedFromAdmin: true,
        isAdditionalWork: true,
        bomTypeId: 2,
        partTotalQtyOnLocal: x.quantity,
        partAvailableQtyOnHand: x.availableQuantity,
        partAvailableQtyOnCentral: x.centralAvailableQty,
        discount:null,
        discountPrice:null,
        packageNo:null,
        packageVersionNo:0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        costPrice:x.unitCost,
        itemGroupCode:x.itemGroupCode,
        lastDirectCost:x.lastDirectCost,
        listPriceLCY:x.listPriceLCY
      });
    });
    this.GetJobsDetailsList();

  }

  async OpenSearchLaborPopUp(index: number) {
    if (this.empty(this.appointmentServiceDetail.appointmentDemandList[index].shortDescription)) {
      let msg = this.translate.instant("lblJobDescNotNull")
      this.toastr.error(msg);
      return;
    }
    this.selectedLaborList = [];
    let currentJobId = this.appointmentServiceDetail.appointmentJobList[index].jobId;
    this.laborService.dealerId = this.editAppointmentService.appointmentDetails.dealerId;
    const modalRef = this.modalService.open(SearchLaborComponent, {
      windowClass: 'pop-wid1366 pop-hig500',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.companyMakeCode = this.contactDetails.companyMakeCode;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.selectedLaborList = this.laborService.selectedLaborList;
      this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          this.saveSearchedLaborDetails(index);
        }
    })
  }

  async saveSearchedLaborDetails(index: number) {
    let billToCustomer = this.appointmentServiceDetail.appointmentDemandList[index].billToCustomer;
    let demand = this.appointmentServiceDetail.appointmentJobList[index].demandNo;
    let job = this.appointmentServiceDetail.appointmentJobList[index].jobId;
    let appointmentJobId = this.appointmentServiceDetail.appointmentJobList[index].id;
    this.selectedLaborList.forEach(x => {
      this.workOrderAdditionalService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "Personnel",
        demandNo: demand,
        description: x.name,
        fixedPrice: x.isFixed ? x.fixedPrice ?? null : null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.laborNo,
        salesPriceWithoutDiscount:0,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: 0,
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice: 0,
        quantity: x.duration,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 3,
        partTotalQtyOnLocal: 0,
        partAvailableQtyOnHand: 0,
        partAvailableQtyOnCentral: 0,
        discount: null,
        discountPrice:null,
        packageNo:null,
        packageVersionNo:0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0
      });
    });
    await this.GetJobsDetailsList()
  }

  async saveSearchedPackageDetails(index: number,includePackagesInJob: boolean) {
    let billToCustomer = this.appointmentServiceDetail.appointmentDemandList[index].billToCustomer;
    let demand = this.appointmentServiceDetail.appointmentJobList[index].demandNo;
    let job = this.appointmentServiceDetail.appointmentJobList[index].jobId;
    let appointmentJobId = this.appointmentServiceDetail.appointmentJobList[index].id;
    if(includePackagesInJob){
    this.appointmentServiceDetail.appointmentJobList[index].packageNo = this.packageVersionBOM[0].packageNumber;
    this.appointmentServiceDetail.appointmentJobList[index].packageVersionNo = this.packageVersionBOM[0].packageVersionNumber;
    this.appointmentServiceDetail.appointmentJobList[index].packageMakeCode = this.selectPackageMakeCode;
    this.appointmentServiceDetail.appointmentJobList[index].packageVersionName = this.selectPackageVersionName;
    }
    this.appointmentServiceDetail.appointmentJobList[index].afxPackageNo = this.packageVersionBOM[0].packageNumber;
    this.appointmentServiceDetail.appointmentJobList[index].afxPackageVersionNo = this.packageVersionBOM[0].packageVersionNumber;
    this.packageVersionBOM.filter(x => x.bomTypeId == 2).forEach(x => {
      this.workOrderAdditionalService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "Material",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.no,
        salesPriceWithoutDiscount: x.unitPrice,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: x.unitPrice,
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice: x.unitPrice,
        quantity: x.quantity,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 2,
        partTotalQtyOnLocal: x.totalQuantityOnLocal ?? 0 ,
        partAvailableQtyOnHand: x.availableQuantity ?? 0 ,
        partAvailableQtyOnCentral: x.centralAvailableQty ?? 0 ,
        discount:null,
        discountPrice:null,
        packageNo: includePackagesInJob? this.packageVersionBOM[0].packageNumber : '',
        packageVersionNo: includePackagesInJob? this.packageVersionBOM[0].packageVersionNumber : 0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: this.selectPackageVersionName,
        afxPackageNo: this.packageVersionBOM[0].packageNumber,
        afxPackageVersionNo: this.packageVersionBOM[0].packageVersionNumber,
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0
      });
    });
    this.packageVersionBOM.filter(x => x.bomTypeId == 1).forEach(x => {
      this.workOrderAdditionalService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId ? appointmentJobId : 0,
        costType: "Personnel",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.no,
        salesPriceWithoutDiscount:x.unitPrice,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: x.unitPrice,
        salesPriceAmountVAT: 0,
        serviceId: x.serviceId,
        unitPrice: x.unitPrice,
        quantity: x.quantity,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 1,
        partTotalQtyOnLocal: 0,
        partAvailableQtyOnHand: 0,
        partAvailableQtyOnCentral: 0,
        discount:null,
        discountPrice:null,
        packageNo: includePackagesInJob? this.packageVersionBOM[0].packageNumber : '',
        packageVersionNo: includePackagesInJob? this.packageVersionBOM[0].packageVersionNumber : 0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: this.selectPackageVersionName,
        afxPackageNo: this.packageVersionBOM[0].packageNumber,
        afxPackageVersionNo: this.packageVersionBOM[0].packageVersionNumber,
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0
      });
    });
    this.packageVersionBOM.filter(x => x.bomTypeId == 3).forEach(x => {
      this.workOrderAdditionalService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "Personnel",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.no,
        salesPriceWithoutDiscount:x.unitPrice,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: x.unitPrice,
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice: x.unitPrice,
        quantity: x.quantity,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 3,
        partTotalQtyOnLocal: 0,
        partAvailableQtyOnHand: 0,
        partAvailableQtyOnCentral: 0,
        discount:null,
        discountPrice:null,
        packageNo: includePackagesInJob? this.packageVersionBOM[0].packageNumber : '',
        packageVersionNo: includePackagesInJob? this.packageVersionBOM[0].packageVersionNumber : 0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: this.selectPackageVersionName,
        afxPackageNo: this.packageVersionBOM[0].packageNumber,
        afxPackageVersionNo: this.packageVersionBOM[0].packageVersionNumber,
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0
      });
    });
    this.packageVersionBOM.filter(x => x.bomTypeId == 4).forEach(x => {
      this.workOrderAdditionalService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: "",
        salesPriceWithoutDiscount:0,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: 0,
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice: 0,
        quantity: 0,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 4,
        partTotalQtyOnLocal: 0,
        partAvailableQtyOnHand: 0,
        partAvailableQtyOnCentral: 0,
        discount:null,
        discountPrice:null,
        packageNo: includePackagesInJob? this.packageVersionBOM[0].packageNumber : '',
        packageVersionNo: includePackagesInJob? this.packageVersionBOM[0].packageVersionNumber : 0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: this.selectPackageVersionName,
        afxPackageNo: this.packageVersionBOM[0].packageNumber,
        afxPackageVersionNo: this.packageVersionBOM[0].packageVersionNumber,
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0
      });
    });
    await this.GetJobsDetailsList()

  }

  deleteJobDetail(index: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblJobDetail"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.workOrderAdditionalService.appointmentJobDetailToUpdate[index].isDeleted = true;
        this.GetJobsDetailsList();
      }
    });
  }

  DeletePackage(index: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblPackage"), false);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        if (this.workOrderAdditionalService.appointmentJobDetailToUpdate.length) {
          let packageNo = this.workOrderAdditionalService.appointmentJobList[index].packageNo;
          let packageVersionNo = this.workOrderAdditionalService.appointmentJobList[index].packageVersionNo;
          let demandNo = this.workOrderAdditionalService.appointmentJobList[index].demandNo;
          let jobId = this.workOrderAdditionalService.appointmentJobList[index].id;
          this.workOrderAdditionalService.appointmentJobDetailToUpdate.forEach(x => {
            if (x.appointmentJobId == jobId && x.demandNo == demandNo && x.packageNo == packageNo && x.packageVersionNo == packageVersionNo) {
              x.isDeleted = true;
            }
          })
          this.workOrderAdditionalService.appointmentJobList[index].packageNo = '';
          this.workOrderAdditionalService.appointmentJobList[index].packageVersionNo = 0;
          this.GetJobsDetailsList();
        } else {
          this.workOrderAdditionalService.appointmentJobList[index].packageNo = '';
          this.workOrderAdditionalService.appointmentJobList[index].packageVersionNo = 0;
          this.GetJobsDetailsList();
        }
      }
    });
  }

  mapJobWithJobDetails(index: number, isPackage: boolean) {
    let billToCustomer = this.appointmentServiceDetail.appointmentDemandList[index].billToCustomer;
    let demand = this.appointmentServiceDetail.appointmentJobList[index].demandNo;
    let job = this.appointmentServiceDetail.appointmentJobList[index].jobId;
    if (!isPackage) {
      this.workOrderAdditionalService.appointmentJobDetailToUpdate = this.appointmentServiceDetail.appointmentJobDetailList.slice();
    }
    if (demand < 100) {
      demand = 101
    }
    if (job < 100) {
      job = 101
    }
    let appointmentJobId = this.appointmentServiceDetail.appointmentJobList[index].id;
    let isAddedFromAdmin = this.appointmentServiceDetail.appointmentJobList[index].isAddedFromAdmin;
    let warningLightNameForJobDemand='';
    this.services.forEach(x => {
      if (x.isServiceChecked) {
        let selectedWarningLightId='';     
        if(x.isWarningLight && this.isWarningLightFeature)
        {
          let warningLightName='';
          warningLightName=' - ';
          x.warningLightService.forEach(element => {
            if(element.isSelected)
            {
              selectedWarningLightId+=element.id+',';
              warningLightName=warningLightName+ element.warningLightName+', ';
            }
            
          });
          warningLightNameForJobDemand=warningLightNameForJobDemand+warningLightName;
        }
        this.workOrderAdditionalService.appointmentJobDetailToUpdate.push({
          jobDetailsId:0,
          appointmentId: this.editAppointmentService.appointmentDetails.id,
          appointmentJobId: appointmentJobId ? appointmentJobId : 0,
          costType: "Personnel",
          demandNo: demand,
          description: warningLightNameForJobDemand!==''? x.name+warningLightNameForJobDemand :x.name ,
          fixedPrice: x.isFixed && x.servicePrice ? x.servicePrice: null,
          id: 0,
          jobId: job,
          plannedQuantity: 0,
          salesPart: x.serviceNo,
          salesPriceWithoutDiscount: 0,
          salesPriceWithoutDiscountInclVAT:0,
          salesPriceAmount: 0,
          salesPriceAmountVAT: 0,
          serviceId: x.id,
          unitPrice: 0,
          quantity: x.duration,
          isAddedFromAdmin: isAddedFromAdmin,
          isAdditionalWork: true,
          bomTypeId: 1,
          partTotalQtyOnLocal: 0,
          partAvailableQtyOnHand: 0,
          partAvailableQtyOnCentral: 0,
          discount:null,
          discountPrice:null,
          packageNo:null,
          packageVersionNo:0,
          billToCustomer:billToCustomer,
          makeCode: x.makeCode,
          selectedWarningLightId:selectedWarningLightId,
          costPrice:0,
          itemGroupCode:"",
          lastDirectCost:0,
          listPriceLCY:0
        });
      }
      if(!this.empty(x.aFxPackageNo)){
        if(x.servicePackageBOM.length > 0){
          this.saveSearchedServiceBOMDetails(index,x.servicePackageBOM);
        }
      }
      this.appointmentServiceDetail.appointmentJobList[index].description= warningLightNameForJobDemand!==''? this.appointmentServiceDetail.appointmentJobList[index].description+warningLightNameForJobDemand :this.appointmentServiceDetail.appointmentJobList[index].description;
      this.appointmentServiceDetail.appointmentDemandList[index].customerRequirement= warningLightNameForJobDemand!==''? x.internalDescription+warningLightNameForJobDemand :x.internalDescription;
      this.appointmentServiceDetail.appointmentDemandList[index].shortDescription= warningLightNameForJobDemand!==''? this.appointmentServiceDetail.appointmentDemandList[index].shortDescription+warningLightNameForJobDemand :this.appointmentServiceDetail.appointmentDemandList[index].shortDescription;
    });

    this.services.forEach(x => {
      x.isServiceChecked = false;
    })
    this.GetJobsDetailsList();
  }

  async saveSearchedServiceBOMDetails(index: number, serviceBOM: ServicePackageBOM[]) {
    let billToCustomer = this.appointmentServiceDetail.appointmentDemandList[index].billToCustomer;
    let demand = this.appointmentServiceDetail.appointmentJobList[index].demandNo;
    let job = this.appointmentServiceDetail.appointmentJobList[index].jobId;
    let appointmentJobId = this.appointmentServiceDetail.appointmentJobList[index].id;
   
    serviceBOM.filter(x => x.bomTypeId == 2).forEach(x => {
      this.workOrderAdditionalService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "Material",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.no,
        salesPriceWithoutDiscount:x.unitPrice,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: x.unitPrice,
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice: x.unitPrice,
        quantity: x.quantity,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 2,
        partTotalQtyOnLocal: x.totalQuantityOnLocal  ?? 0 ,
        partAvailableQtyOnHand: x.availableQuantity ?? 0 ,
        partAvailableQtyOnCentral: x.centralAvailableQty  ?? 0 ,
        discount: null,
        discountPrice: null,
        packageNo: "",
        packageVersionNo: 0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: this.selectPackageVersionName,
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0
      });
    });
    serviceBOM.filter(x => x.bomTypeId == 1).forEach(x => {
      this.workOrderAdditionalService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId ? appointmentJobId : 0,
        costType: "Personnel",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.no,
        salesPriceWithoutDiscount:0,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: 0,
        salesPriceAmountVAT: 0,
        serviceId: x.serviceId,
        unitPrice: 0,
        quantity: x.quantity,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 1,
        partTotalQtyOnLocal: 0,
        partAvailableQtyOnHand: 0,
        partAvailableQtyOnCentral: 0,
        discount: null,
        discountPrice: null,
        packageNo: "",
        packageVersionNo: 0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: this.selectPackageVersionName,
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0
      });
    });
    serviceBOM.filter(x => x.bomTypeId == 3).forEach(x => {
      this.workOrderAdditionalService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "Personnel",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.no,
        salesPriceWithoutDiscount:0,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: 0,
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice:0,
        quantity: x.quantity,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 3,
        partTotalQtyOnLocal: 0,
        partAvailableQtyOnHand: 0,
        partAvailableQtyOnCentral: 0,
        discount: null,
        packageNo: "",
        packageVersionNo: 0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: this.selectPackageVersionName,
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0
      });
    });
    serviceBOM.filter(x => x.bomTypeId == 4).forEach(x => {
      this.workOrderAdditionalService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: "",
        salesPriceWithoutDiscount:x.unitPrice,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: 0,
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice: 0,
        quantity: 0,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 4,
        partTotalQtyOnLocal: 0,
        partAvailableQtyOnHand: 0,
        partAvailableQtyOnCentral: 0,
        discount: null,
        discountPrice: null,
        packageNo: "",
        packageVersionNo: 0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: this.selectPackageVersionName,
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0
      });
    });
  }
  
  GetServiceAsDemand() {
    let selectedService = this.services.filter(x => x.isServiceChecked);
  
    if (this.appointmentServiceDetail.appointmentDemandList.length === 0) {
      this.createNewDemand(selectedService[0]);
    } else {
      let lastDemandNoForDemand = this.getLastDemandNo() + 1;
      if (lastDemandNoForDemand < 100) {
        lastDemandNoForDemand = 101;
      }
      let demand = {
        id: 0,
        demandNo: lastDemandNoForDemand,
        shortDescription: selectedService[0].name,
        customerRequirement: selectedService[0].internalDescription,
        preApproval: "",
        isAddedFromAdmin: true,
        isInWarranty: false,
        isDeleted: false,
        fixedPrice: null,
        sumPerService: selectedService[0].price,
        sumPerServiceInclTax: selectedService[0].price,
        isAdditionalWork: true,
        totalPriceInclVAT: 0,
        sumPerServiceWithoutDiscountInclVAT: selectedService[0].price,
        billToCustomer: this.contactDetails.billtoCustomerNo,
        sstOperationId : '',
        sstOperationCode: '',
        demandStaus:''
      };
      this.appointmentServiceDetail.appointmentDemandList.push(demand);
      this.allAppointmentDemandList.push(demand);
  
      let lastDemandNoForJob = this.getLastDemandNo();
      if (lastDemandNoForJob < 100) {
        lastDemandNoForJob = 101;
      }
  
      this.appointmentServiceDetail.appointmentJobList.push({
        id: 0,
        demandNo: lastDemandNoForJob,
        jobId: lastDemandNoForJob,
        description: selectedService[0].name,
        appointmentDemandId: 0,
        fixedPrice: null,
        price: selectedService[0].price,
        salesPriceWithoutDiscountInclVAT: selectedService[0].price,
        totalTime: selectedService[0].duration,
        isAddedFromAdmin: true,
        isAdditionalWork: true,
      });
  
      this.services.forEach(x => {
        if (x.isServiceChecked) {
          this.createJobDetailToUpdate(x, lastDemandNoForJob);
          if (!this.empty(x.aFxPackageNo) && x.servicePackageBOM.length > 0) {
            this.saveSearchedServiceBOMDetails(
              this.appointmentServiceDetail.appointmentJobList.length - 1,
              x.servicePackageBOM
            );
          }
        }
      });
    }
  
    this.services.forEach(x => {
      x.isServiceChecked = false;
    });
    this.GetJobsDetailsList();
  }
  
  createNewDemand(service) {
    let demand = {
      id: 0,
      demandNo: 101,
      shortDescription: service.name,
      customerRequirement: service.internalDescription,
      preApproval: "",
      isAddedFromAdmin: true,
      isInWarranty: false,
      isDeleted: false,
      fixedPrice: null,
      sumPerService: service.price,
      sumPerServiceInclTax: service.price,
      isAdditionalWork: true,
      totalPriceInclVAT: 0,
      sumPerServiceWithoutDiscountInclVAT: service.price,
      billToCustomer: this.contactDetails.billtoCustomerNo,
      sstOperationId : '',
      sstOperationCode: '',
      demandStaus:''
    };
    this.appointmentServiceDetail.appointmentDemandList.push(demand);
  
    this.appointmentServiceDetail.appointmentJobList.push({
      id: 0,
      demandNo: 101,
      jobId: 101,
      description: service.name,
      appointmentDemandId: 0,
      fixedPrice: null,
      price: service.price,
      salesPriceWithoutDiscountInclVAT: service.price,
      totalTime: service.duration,
      isAddedFromAdmin: true,
      isAdditionalWork: true,
    });
  
    this.services.forEach(x => {
      if (x.isServiceChecked) {
        this.createJobDetailToUpdate(x, 101);
        if (!this.empty(x.aFxPackageNo) && x.servicePackageBOM.length > 0) {
          this.saveSearchedServiceBOMDetails(
            this.appointmentServiceDetail.appointmentJobList.length - 1,
            x.servicePackageBOM
          );
        }
      }
    });
  
    this.allAppointmentDemandList.push(this.appointmentServiceDetail.appointmentDemandList[0]);
  }
  
  createJobDetailToUpdate(service, lastDemandNoForJob) {
    
    this.workOrderAdditionalService.appointmentJobDetailToUpdate.push({
      jobDetailsId:0,
      appointmentId: this.editAppointmentService.appointmentDetails.id,
      appointmentJobId: lastDemandNoForJob + 1,
      costType: "Personnel",
      demandNo: lastDemandNoForJob,
      description: service.name,
      fixedPrice: service.isFixed && service.servicePrice ? service.servicePrice: null,
      id: 0,
      jobId: lastDemandNoForJob,
      plannedQuantity: 0,
      salesPart: service.serviceNo,
      salesPriceWithoutDiscount: 0,
      salesPriceWithoutDiscountInclVAT: 0,
      salesPriceAmount: 0,
      salesPriceAmountVAT: 0,
      serviceId: service.id,
      unitPrice:  0,
      quantity: service.duration,
      isAddedFromAdmin: true,
      isAdditionalWork: true,
      bomTypeId: 1,
      partTotalQtyOnLocal: 0,
      partAvailableQtyOnHand: 0,
      partAvailableQtyOnCentral: 0,
      discount:  null,
      discountPrice: null,
      packageNo: null,
      packageVersionNo: 0,
      billToCustomer: this.contactDetails.billtoCustomerNo,
      makeCode: service.makeCode,
      costPrice:0,
      itemGroupCode:"",
      lastDirectCost:0,
      listPriceLCY:0
    });
  }
  
  getLastDemandNo() {
    return this.allAppointmentDemandList[this.allAppointmentDemandList.length - 1].demandNo;
  }
 
  
  
  
  
 async SaveAndClose() {
    //final update method
    const appointmentId = this.editAppointmentService.appointmentDetails.id;
    // Same duplicate-demand/job guard as the main Work Order Save: blocks this while
    // GetJobsDetailsList() (the Save button / any Add-Service-as-Demand auto-save on this tab)
    // already has an UpdateAdditionalAppointment call in flight for this appointment.
    if (this.workOrderAdditionalService.isSavingAppointment(appointmentId)) {
      return;
    }
    let viewModel = this.workOrderAdditionalService.MapToViewModel(false, false);
    //To Get latest itemgroup code and cost price to calculate item price changes done by dharmendra on 9 Oct 2024
    viewModel = await this.workOrderAdditionalService.GetPartCostAndItemGroupCode(viewModel,true);
    // Finish to get part price.
    if (viewModel.AppointmentDemandList && viewModel.AppointmentDemandList?.length > 0) {
      this.workOrderAdditionalService.beginSave(appointmentId);
      this.spinner.show();
      try {
     await  this.appointmentService.UpdateAdditionalAppointment(viewModel)
        .then((response) => {
          if (response.responseObject.result) {
            this.OnClose()
          }
          this.spinner.hide();
        }, _error => {
          this.spinner.hide();
        });
      } finally {
        this.workOrderAdditionalService.endSave(appointmentId);
      }
    }
    else {
      let msg = this.translate.instant("lblJobDescNotNull")
      this.toastr.error(msg);
    }
  }


  async GetJobsDetailsList() {
    //final update method
    const appointmentId = this.editAppointmentService.appointmentDetails.id;
    // Guards against firing while SaveAndClose() or another auto-save call for this same
    // appointment already has an UpdateAdditionalAppointment call in flight - otherwise both
    // requests can carry the same not-yet-persisted (Id=0) demand/job/job-detail and duplicate
    // it, the same way the main Work Order screen's Add-Service-as-Demand flow could.
    if (this.workOrderAdditionalService.isSavingAppointment(appointmentId)) {
      return;
    }
    let viewModel = this.workOrderAdditionalService.MapToViewModel(false, false);
    //To Get latest itemgroup code and cost price to calculate item price changes done by dharmendra on 9 Oct 2024
    viewModel = await this.workOrderAdditionalService.GetPartCostAndItemGroupCode(viewModel,true);
    // Finish to get part price.
    if (viewModel.AppointmentDemandList && viewModel.AppointmentDemandList?.length > 0) {
      this.workOrderAdditionalService.beginSave(appointmentId);
      this.spinner.show();
      try {
      await this.appointmentService.UpdateAdditionalAppointment(viewModel)
        .then(async (response) => {
          if (response.responseObject.result) {
            // Awaited so the guard doesn't release until the local model is actually resynced
            // with server-assigned Ids (same fix as the main Work Order save paths).
            await this.GetAdditionalServiceDetail();
          }
          this.spinner.hide();
        }, _error => {
          this.spinner.hide();
        });
      } finally {
        this.workOrderAdditionalService.endSave(appointmentId);
      }
    }
    else {
      let msg = this.translate.instant("lblJobDescNotNull")
      this.toastr.error(msg);
    }
  }

  checkJobQty(e, _i) {
    if (e !== "") {
      this.workOrderAdditionalService.demandQtyCheckflag = true;
    }
    else {
      this.workOrderAdditionalService.demandQtyCheckflag = false;
    }
  }

  isQtyPrice(event, value) {
    if (!this.cultureLocaleService.isQtyPrice(event, value)) {
      let msg = this.translate.instant("lblValidValue");
      this.toastr.error(msg)
      event.preventDefault();
    }
  }

  isPrice(events): void {
    const isDigit = Utility.isDigit(events);
    const isDecimalPoint = Utility.isDecimalPoint(events);
    if (!isDecimalPoint && !isDigit) {
      events.preventDefault();
    }
  }

 async SaveAppointmentData() {

    // Additional Work Update appointment - calls the same UpdateAppointment endpoint as the
    // main Work Order Save button, so it shares that guard (workOrderAdditionalService and
    // workOrderService are the same providedIn:'root' singleton) to avoid duplicating a demand
    // if both screens save the same appointment while the other's request is still in flight.
    const appointmentId = this.editAppointmentService.appointmentDetails.id;
    if (this.workOrderAdditionalService.isSavingAppointment(appointmentId)) {
      return;
    }
    this.workOrderAdditionalService.isUpdateAppointment = true;
    this.workOrderAdditionalService.beginSave(appointmentId);
    try {
    let viewModel = this.workOrderAdditionalService.MapToViewModel(false, false);
    if (viewModel.AppointmentDemandList == 0) {
      let errorMessage = "Please Add service Details";
      this.toastr.error(errorMessage);
      return;
    }
    this.spinner.show();
    //To Get latest itemgroup code and cost price to calculate item price changes done by dharmendra on 9 Oct 2024
    viewModel = await this.workOrderAdditionalService.GetPartCostAndItemGroupCode(viewModel,true);
    // Finish to get part price.
    await this.appointmentService.UpdateAppointment(viewModel)
      .then(async (response) => {
        if (response.responseObject.result) {
          //Show dms response failed message
          if(!this.empty(response.responseObject.result.dmsFailedMessage)){
            this.toastr.error(response.responseObject.result.dmsFailedMessage);
          }
          const result = response.responseObject?.result;
          const isDataNotFound = result?.errorCode === Enums.ErrorCodes.DataNotFound;
          if (isDataNotFound) {
            this.spinner.hide();
            let errorMessage = this.translate.instant("lblAppointmentDeleted");
            this.toastr.error(errorMessage);
          }
          else if (response.responseObject.result?.isAlreadyModifiedAppointment)
          {
            this.spinner.hide();
            let errorMessage = this.translate.instant("lblAppointmentAlreadyModified");
            this.toastr.error(errorMessage);
          }
         else{
          this.workOrderAdditionalService.isUpdateAppointment = false;
          let successMessage = this.translate.instant("lblAppointmentSaved");
          this.toastr.success(successMessage);
          this.spinner.show();
          
          this.contactDetails.appointmentChangeVersion = response.responseObject.result.appointmentChangeVersion;
          // Awaited so the beginSave/endSave guard doesn't release until the local demand/job
          // model is actually resynced with server-assigned Ids (see the same fix applied to
          // the main Work Order Save and to GetJobsDetailsList).
          await this.appointmentService.GetServiceDetail(this.editAppointmentService.appointmentDetails.id, '').then(data => {

            const hasErrors = data.responseObject?.errorCount > 0;
            if (hasErrors) {
              this.spinner.hide();
              this.appointmentServiceDetail = {
                totalPrice: 0,
                totalTime: 0,
                totalInvoicePrice: 0,
                rentalCompanyMakeName: '',
                priceForDisply: '',
                appointmentDemandList: [],
                appointmentJobDetailList: [],
                appointmentJobList: [],
                appointmentPriceDetails: []
              }
              this.workOrderAdditionalService.totalPrice = null;
              this.workOrderAdditionalService.totalTime = null;
              this.workOrderAdditionalService.totalInvoicePrice = null;

            }
            else {
              this.spinner.hide();
              this.appointmentServiceDetail = data.responseObject;
              this.workOrderAdditionalService.appointmentDemandList = this.appointmentServiceDetail.appointmentDemandList;
              this.workOrderAdditionalService.appointmentJobList = this.appointmentServiceDetail.appointmentJobList;
              this.workOrderAdditionalService.appointmentJobDetailList = this.appointmentServiceDetail.appointmentJobDetailList;
              this.workOrderAdditionalService.totalPrice = this.appointmentServiceDetail.totalPrice;
              this.workOrderAdditionalService.totalTime = this.appointmentServiceDetail.totalTime;
              this.workOrderAdditionalService.totalInvoicePrice = this.appointmentServiceDetail.totalInvoicePrice;
              this.workOrderAdditionalService.appointmentJobDetailToUpdate = this.appointmentServiceDetail.appointmentJobDetailList.slice();
              this.workOrderAdditionalService.getOverallAmountForAppointment();
            }

          })
         }
        }
        else {
          let errorMessage = this.translate.instant("lblErrorMessage");
          this.toastr.error(errorMessage);
        }
        this.spinner.hide();
      }, _error => {
        this.spinner.hide();
      });
    } finally {
      this.workOrderAdditionalService.endSave(appointmentId);
    }
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  OnClose() {
    this.activeModal.close({success: false});
  }
  async onRefreshStock() {
    if (this.appointmentServiceDetail.appointmentJobDetailList.length == 0) {
      return;
    }
    if(localStorage.getItem("Theme") === 'mg'){
      let model : any = {}
      let partArray : PartNumberMultiInventeryModel[] = [];

      this.appointmentServiceDetail.appointmentJobDetailList.forEach(async (obj) => {
        if (obj.costType == "Material") {
          let part : PartNumberMultiInventeryModel = {part_number : obj.salesPart};
          partArray.push(part);
        }
      });
      model.af_dealerid = this.contactDetails.dealerDmsNo,
      model.parts = partArray;
      this.spinner.show();
      await this.partService.GetMultiInventoryParts(model).then(response => {
        this.spinner.hide();
        this.appointmentServiceDetail.appointmentJobDetailList.forEach(async (obj) => {
          if (obj.costType == "Material") {
             obj.partAvailableQtyOnCentral = response.find(f=>f.partNumber == obj.salesPart).centralAvailableQuantity;
             obj.partAvailableQtyOnHand = response.find(f=>f.partNumber == obj.salesPart).onHandQuantity;
             obj.partTotalQtyOnLocal = response.find(f=>f.partNumber == obj.salesPart).localQuantity;
          }
        });
      });

    }else{
      this.appointmentServiceDetail.appointmentJobDetailList.forEach(async (obj) => {
        if (obj.costType == "Material") {
          this.spinner.show();
          let model =   {
            locationCode: this.contactDetails.locationCode,
            no: obj.salesPart,
            languageCode: this.cookieservice.get('userSelectedLanguage')
          }
          await this.partService.GetInventoryParts(model).then(response => {
            this.spinner.hide();
            obj.partAvailableQtyOnCentral = response.centralAvailableQuantity;
            obj.partAvailableQtyOnHand = response.onHandQuantity;
            obj.partTotalQtyOnLocal = response.localQuantity;
          });
        }
      });
    }
  }

  async getAlternatePart(i) {
    let partNumber = this.workOrderAdditionalService.appointmentJobDetailToUpdate[i].salesPart;
    this.partService.searchPartNumber = partNumber;

    const modalAlterRef = this.modalService.open(SearchAlternatePartsComponent, {
      windowClass: 'pop-wid1000 pop-hig500',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });

    modalAlterRef.result.then((_result) => {
       // This is intentional
     }, (reasons) => {
      this.popupCloseResult = this.getDismissReason(reasons);
      if (this.popupCloseResult) {
        if (this.partService.selectedPartListWithAddtionalItems.length > 0) {
          this.updateSearchedAlterPartsDetails(i);
          modalAlterRef.dismiss(true);
        }
      }
    })
  }

  async updateSearchedAlterPartsDetails(index: number) {
    this.workOrderAdditionalService.appointmentJobDetailToUpdate[index].salesPart = this.partService.selectedPartListWithAddtionalItems[0].partNumber;
    this.workOrderAdditionalService.appointmentJobDetailToUpdate[index].description = this.partService.selectedPartListWithAddtionalItems[0].description;
    this.workOrderAdditionalService.appointmentJobDetailToUpdate[index].salesPriceAmount = this.partService.selectedPartListWithAddtionalItems[0].unitPrice;
    this.workOrderAdditionalService.appointmentJobDetailToUpdate[index].unitPrice = this.partService.selectedPartListWithAddtionalItems[0].unitPrice;
    this.workOrderAdditionalService.appointmentJobDetailToUpdate[index].quantity = this.partService.selectedPartListWithAddtionalItems[0].qty;
    this.workOrderAdditionalService.appointmentJobDetailToUpdate[index].partTotalQtyOnLocal = this.partService.selectedPartListWithAddtionalItems[0].quantity;
    this.workOrderAdditionalService.appointmentJobDetailToUpdate[index].partAvailableQtyOnHand = this.partService.selectedPartListWithAddtionalItems[0].availableQuantity;
    this.workOrderAdditionalService.appointmentJobDetailToUpdate[index].partAvailableQtyOnCentral = this.partService.selectedPartListWithAddtionalItems[0].centralAvailableQty;
    this.workOrderAdditionalService.appointmentJobDetailToUpdate[index].costPrice = this.partService.selectedPartListWithAddtionalItems[0].unitCost;
    this.workOrderAdditionalService.appointmentJobDetailToUpdate[index].itemGroupCode = this.partService.selectedPartListWithAddtionalItems[0].itemGroupCode;
    this.partService.selectedPartListWithAddtionalItems = [];
    this.partService.searchPartNumber = '';
     this.GetJobsDetailsList()
  }

  getReplacementPart(i) {
    let partNumber = this.workOrderAdditionalService.appointmentJobDetailToUpdate[i].salesPart;
    this.partService.searchPartNumber = partNumber;

    const modalAlterRef = this.modalService.open(SearchReplacementPartsComponent, {
      windowClass: 'pop-wid1000 pop-hig500',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });

    modalAlterRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        if (this.partService.selectedPartListWithAddtionalItems.length > 0) {
          this.updateSearchedAlterPartsDetails(i);
          modalAlterRef.dismiss(true);
        }
      }
    })
  }
  //#region Warranty Document
  onInWarrantyChange(event, idx) {
    if (this.isWarrantyDocumentSigned) {
      event.preventDefault();
      let modelHeadermsg = this.translate.instant("lblDocumentAlreadySigned");
      let modelBodymsg = event.currentTarget.checked ? this.translate.instant("lblWarrantyCanNotChange") : this.translate.instant("lblWarrantyCanNotRemove");
      const modalRef = this.modalService.open(NgInfoModalContent, { size: 'lg' });
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
    }
    else {
      this.checkWarranty(idx);
    }
  }
  async GetWarrantyDocumentStatus() {
    let workOrderNo = this.editAppointmentService.appointmentDetails.workOrderNo;
    let dealerId = this.editAppointmentService.appointmentDetails.dealerId;
    await this.documentService.WarrantyDocumentStatus(workOrderNo,dealerId).then(
      (res) => {
        this.isWarrantyDocumentSigned = res.responseObject
      }
    );
  }

  selectAllDemands(event: any) {
    if (event.target.checked) {
      this.isAllDemandSelected = true
      this.serviceList = []
      this.customerRejectedDemand.forEach(demand => {
        this.selectDemand(event, demand)
      });
    }
    else {
      this.isAllDemandSelected = false
      this.customerRejectedDemand.forEach(demand => {
        demand.isChecked = false
      });
      this.serviceList = []
    }
  }
  selectDemand(event: any, demand: any) {
    if (event.target.checked ) {
      demand.isChecked = true
      let reject = this.serviceList.filter(x => x.id == demand.id)
      if (reject.length == 0) {
        this.serviceList.push(demand)
      }
    }
    else {
      demand.isChecked = false
      this.serviceList = this.serviceList.filter(x => x.id != demand.id);
      this.isAllDemandSelected = false
    }
    if (this.serviceList.length == this.customerRejectedDemand.length) {
      this.isAllDemandSelected = true
    }
  }

  SaveQuote() {
    if (this.serviceList.length == 0) {
      return;
    }
    let modelHeadermsg = this.translate.instant("lblConvertToQuote");
    let modelBodymsg = this.translate.instant("lblConvertToQuoteMessage");
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        let demandViewModel = this.workOrderAdditionalService.mapUpdateDemandViewModel(this.serviceList, false);

        this.spinner.show();
        let viewModel = {
          refAppointmentId: this.editAppointmentService.appointmentDetails.id,
          IFSWorkOrderNumber: this.editAppointmentService.appointmentDetails.workOrderNo,
          customerDefaultLanguage: this.cookieservice.get('userSelectedLanguage'),
          appointmentDemandList: demandViewModel,
        }
        this.appointmentService.AddAppointmentAsQuoteFromRejectedDemand(viewModel).then(res => {
          if (res.responseCode === Constant.SuccessResponseCode) {
            this.appointmentService.isRefreshListing = true;
            this.spinner.hide();
            let successMessage = this.translate.instant("lblQuoteCreated");
            this.toastr.success(successMessage);
            this.GetAdditionalServiceDetail();
          }
          else {
            this.spinner.hide();
            let errorMessage = this.translate.instant("lblErrorMessage");
            this.toastr.error(errorMessage);
          }
        }).finally(() => {
          this.spinner.hide();
        });
      }
    });

  }
  //#endregion
}
